import Vue from 'vue';

import { buildFetchMutations } from '@/store/extensions/fetch';
import { buildCreateMutations } from '@/store/extensions/create';
import { buildUpdateMutations } from '@/store/extensions/update';
import { buildDeleteMutations } from '@/store/extensions/delete';

export default {
  ...buildFetchMutations(['fetchComments', 'fetchSingleComment']),
  ...buildCreateMutations(['createComment']),
  ...buildUpdateMutations(['updateComment']),
  ...buildDeleteMutations(['deleteComment']),

  openFormModal: (state, payload = null) => {
    Vue.set(state, 'formModalContext', payload);
    Vue.set(state, 'formModalOpened', true);
  },

  closeFormModal: (state) => {
    Vue.set(state, 'formModalOpened', false);
    Vue.set(state, 'formModalContext', null);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/comment/mutations.js